module.exports = __webpack_public_path__ + "assets/img/3.00e2ec1a.jpg";